import React, { useEffect, useRef } from 'react'
import $ from 'jquery'
import 'autocomplete.js/index_jquery.js'
import _ from 'lodash'

import './AutoComplete.css'

function AutoComplete({ options: optionsProp, datasets: datasetsProp, handleSelect, initialValue, disabled }) {
  const inputRef = useRef(null)

  useEffect(() => {
    const input = inputRef.current
    if (!input) return

    let options = optionsProp || { hints: false }
    let datasets = [].concat(datasetsProp || []).map(dataset => {
      dataset = _.extend({}, dataset)
      const sourceOptions = dataset.sourceOptions || { hitsPerPage: 5 }
      delete dataset.sourceOptions
      // An Algolia index is wrapped as a hits source; a plain
      // (query, callback) function is used as-is.
      if (dataset.source && typeof dataset.source.search === 'function') {
        dataset.source = $.fn.autocomplete.sources.hits(dataset.source, sourceOptions)
      }
      dataset.templates = dataset.templates || {}
      dataset.templates.suggestion =
        dataset.templates.suggestion ||
        (suggestion => {
          if (suggestion._highlightResult[dataset.displayKey]) {
            return suggestion._highlightResult[dataset.displayKey].value
          }
          return suggestion[dataset.displayKey]
        })
      return dataset
    })

    const $input = $(input)
    $input.autocomplete(options, datasets)
    $input.on('autocomplete:selected', handleSelect)
    $input.autocomplete('val', initialValue || '')

    return () => {
      $input.off('autocomplete:selected', handleSelect)
      $input.autocomplete('destroy')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <input
      type="text"
      ref={inputRef}
      disabled={disabled}
    />
  )
}

export default AutoComplete
